import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import {FileUpload} from "primereact/fileupload";

const DocsUploadComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    //document_template: 1
  });
  const [categories, setCategories] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    apiCall('post', '/api/v2/document/upload', data)
      .then(response => {
        window.App.toastShow('success', t('toastSaveSuccess'));
        window.App.setState({rerenderDocsList: Math.random()})
        if (props.goback === true) {
          history.push(props.backlink);
        } else {
          history.push('/docs/update/' + response.data.data.id);
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/document-category')
      .then(response => {
        setCategories(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().calendarCategoryId) || (entity === 'docs' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/document/' + (window.App.urlVars().docsId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
    if (entity !== 'docs' && id) {
      setFormData({
        ...formData,
        related_entity_id: id
      })
    }
  }, [])

  return (
    <div className={"docs-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="document_category" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="document_category"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldCategory')}</label>
                  <span className="p-d-block">
                     <Dropdown options={categories}
                               id={"document_category"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noCategoryYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   document_category: e.value
                                 })
                               }}
                               value={Number(window.App.urlVars().categoryId) || formData.document_category?.id || formData.document_category}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-12"}>
              <div className="p-field p-fluid">
                <label htmlFor="upload">{t('fieldFile')}</label>
                <span className="p-d-block">
                     {/*<FileUpload mode="basic"*/}
                     {/*            auto*/}
                     {/*            disabled={loading}*/}
                     {/*            chooseLabel={"File kiválasztása"}*/}
                     {/*            name="upload"*/}
                     {/*            onSelect={(e) => {*/}
                     {/*              const _formData = new FormData();*/}
                     {/*              _formData.append('file', e.files[0]);*/}
                     {/*              setLoading(true)*/}
                     {/*              apiCall('post', '/api/v2/file/upload', _formData)*/}
                     {/*                .then(response => {*/}
                     {/*                  setFormData({*/}
                     {/*                    ...formData,*/}
                     {/*                    name: e.files[0].name,*/}
                     {/*                    file: response.data.data.id,*/}
                     {/*                  })*/}
                     {/*                  setLoading(false)*/}
                     {/*                  window.App.toastShow('success', t('success'), response.data.message)*/}
                     {/*                })*/}
                     {/*                .catch(error => {*/}
                     {/*                  setLoading(true)*/}
                     {/*                  window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
                     {/*                })*/}
                     {/*            }}*/}
                     {/*/>*/}
                  <FileUpload
                    mode="basic"
                    name="upload"
                    auto={true}
                    chooseLabel={props.t('chooseFile')}
                    customUpload
                    uploadHandler={(event) => {
                      const file = event.files[0];
                      const _formData = new FormData();
                      _formData.append("file", file);
                      setLoading(true);
                      apiCall("post", "/api/v2/file/upload", _formData)
                        .then((response) => {
                          setFormData({
                            ...formData,
                            file: response.data.data.id,
                            name: event.files[0].name
                          });
                          setLoading(false);
                          window.App.toastShow("success", t('toastFileUploaded'));
                        })
                        .catch((error) => {
                          setLoading(false);
                          window.App.toastShow("error", t('toastError'), error.message);
                        });
                    }}
                  />

                    </span>
              </div>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'docs' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(DocsUploadComponent);
